import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import FieldData2 from './FieldData2';
import {
  Box,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import { Search } from '@mui/icons-material';
import TotalBillAmount from 'src/views/Branch/components/TotalBillAmount';
import ExpiryBranches from 'src/views/Branch/components/ExpiryBranches';
import LatestSubscriptionUpdate from 'src/views/Branch/components/LatestSubscriptionUpdate';
const AllBranch = () => {
  const [data, setData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterBy, setFilterBy] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const { fetchAllBillingAndMsgStatus } = useMain();

  const filteredData = (data || []).filter((item) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    const name = item.branchName?.toLowerCase() || '';
    const phone = item.branchPhone || item.phone || '';
    return name.includes(term) || phone.includes(term);
  });

  const getData = async () => {
    setShowLoader(true);
    const params = { limit: rowsPerPage, page: activePage };
    if (filterBy) params.filterBy = filterBy;
    if (searchTerm) params.search = searchTerm;
    if (filterBy === 'customDate' && startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
    const res = await fetchAllBillingAndMsgStatus(params);
    setData(res?.data?.branches);
    setShowLoader(false);
  };

  useEffect(() => {
    if (filterBy === 'customDate' && (!startDate || !endDate)) {
      return;
    }
    getData();

    return () => {};
  }, [activePage, filterBy, startDate, endDate, searchTerm, rowsPerPage]);

  return (
    <PageContainer title="Branches" description="this contains all products">
      <Grid container spacing={0} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <TotalBillAmount filterBy={filterBy} startDate={startDate} endDate={endDate} />
        </Grid>
        <Grid container spacing={2} sx={{ mt: 1, mb: 3 }} alignItems="center">
          <Grid item xs={12} sm={2}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Show per page</InputLabel>
              <Select value={rowsPerPage} onChange={(e) => {
                setRowsPerPage(e.target.value);
                setActivePage(1);
              }}>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Filter By</InputLabel>
              <Select
                value={filterBy}
                onChange={(e) => {
                  const value = e.target.value;
                  setFilterBy(value);
                  setActivePage(1);
                  if (value !== 'customDate') {
                    setStartDate('');
                    setEndDate('');
                  }
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="Today">Today</MenuItem>
                <MenuItem value="Current Week">Current Week</MenuItem>
                <MenuItem value="Current Month">Current Month</MenuItem>
                <MenuItem value="Current Year">Current Year</MenuItem>
                <MenuItem value="customDate">Custom Date</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {filterBy === 'customDate' && (
            <>
              <Grid item xs={12} sm={2}>
                <TextField
                  label="Start Date"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  label="End Date"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </>
          )}
          <Grid item xs container justifyContent="flex-end">
            <TextField
              label="Search"
              variant="standard"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setActivePage(1);
              }}
              style={{
                maxWidth: '300px',
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <ExpiryBranches filterBy={filterBy} startDate={startDate} endDate={endDate} searchTerm={searchTerm} />
        </Grid>
        <Grid item xs={12} sx={{ mt: 3 }}>
          <LatestSubscriptionUpdate />
        </Grid>
      </Grid>
      <DashboardCard2 title="Branches">
        {/* <Grid container spacing={2} sx={{ mt: 1, mb: 3 }} alignItems="center">
          <Grid item xs={12} sm={2}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Show per page</InputLabel>
              <Select value={10} onChange={() => {}}>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Filter By</InputLabel>
              <Select
                value={filterBy}
                onChange={(e) => {
                  const value = e.target.value;
                  setFilterBy(value);
                  if (value !== 'customDate') {
                    setStartDate('');
                    setEndDate('');
                  }
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="Today">Today</MenuItem>
                <MenuItem value="Current Week">Current Week</MenuItem>
                <MenuItem value="Current Month">Current Month</MenuItem>
                <MenuItem value="Current Year">Current Year</MenuItem>
                <MenuItem value="customDate">Custom Date</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {filterBy === 'customDate' && (
            <>
              <Grid item xs={12} sm={2}>
                <TextField
                  label="Start Date"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  label="End Date"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </>
          )}
          <Grid item xs container justifyContent="flex-end">
            <TextField
              label="Search"
              variant="standard"
              style={{
                maxWidth: '300px',
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid> */}
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <FieldData2 data={filteredData} setData={setData} />
            </Grid>
          </Grid>
        </Box>
        {showLoader && <ShowLoader value={showLoader} />}
      </DashboardCard2>
    </PageContainer>
  );
};

export default AllBranch;
